import React from 'react';
import { useNavigate } from 'react-router-dom';
import classNames from 'classnames';
import CommonButton from '../../common/components/CommonButton';
import { CommonButtonVariants } from '../../constants/CommonButtonVariants';
import crimsonCar from '../../assets/img/tsv-auth-car.png';

function LoginPromptBanner({
  title = (
    <>
      Already <br /> one of us?
    </>
  ),
  subtitle = 'If you already have an account, simply login in to unlock the stock.',
  btnLabel = 'LOG IN',
  className = '',
}) {
  const navigate = useNavigate();

  const handleSignUpClick = () => {
    navigate('/login');
  };

  return (
    <div className={classNames('banner-content', className)}>
      <div className="banner-text-content">
        <h3 className="banner-title">{title}</h3>
        <p className="banner-subtitle">{subtitle}</p>
        <CommonButton
          label={btnLabel}
          variant={CommonButtonVariants.PRIMARY_RED}
          className="banner-login-btn w-100"
          handleClick={handleSignUpClick}
        />
      </div>
      <div className="banner-image">
        <img src={crimsonCar} alt="Car" className="banner-car-image" />
      </div>
    </div>
  );
}

export default LoginPromptBanner;
